const LoadingPage = () => (
  <div className="page-loader-container">
    <div className="page-loader" />
  </div>
);

export default LoadingPage;
